/* eslint-disable react-hooks/exhaustive-deps */
import { useNavigate } from "react-router-dom";
import { ApiConfigData, ClientPlatformCode, DefaultCardName, handleRedirectWithLoading, ModalOrSso, trackEvent, UserIdAndStatusData, UtilityReducer, VoucherHistoryReducer } from "../../Utility/Utility";
import getTranslation from "../../TranslationUtility/TranslationUtility";
import { useSelector } from "react-redux";
import arrowDownIcon from "../../Assets/img/arrow-down.svg";

const MyActivity = ({
  title,
  onClose,
  setIsLoading,
  apiconfig,
  login,
  setShowModal,
  isOpen
}) => {
  const navigate = useNavigate();
  const card = UtilityReducer();
  const apiConfigData = ApiConfigData();
  const clientMasterData = useSelector((state) => state.clientMasterReducer);
  const clientCode = clientMasterData?.clientMasterData?.[0]?.clientCode || "";

  const { clientCode: clientPlatformCode, platformCode } = ClientPlatformCode();
  const { userId, userStatus } = UserIdAndStatusData();
  const defaultCardName = DefaultCardName();
  const isVouchersHistory = useSelector((state) => state.homePageSliceReducer)?.homePageData?.isVouchersHistory;

  const integrationId = apiConfigData?.find(
    (data) => data?.paramsKey === "integrationId"
  )?.paramsValue;

  const karmaRedirectionUrl = apiConfigData?.find(
    (data) => data?.paramsKey === "karmaRedirectionUrl"
  )?.paramsValue;

  const myActivityString = apiConfigData?.find(
    (data) => data?.paramsKey === "myactivity"
  )?.paramsValue;

  const myActivityData = JSON?.parse(myActivityString || []);
  myActivityData?.sort((a, b) => a.order - b.order);


  const loginUrl = `${process.env.REACT_APP_INTEGRATION_LOGIN_URL}Login/${integrationId}`;
  const isModal = ModalOrSso();
  const translation = getTranslation();
  const tripStaccUrl = apiconfig?.find(
    (data) => data?.paramsKey === "tripStaccUrl"
  )?.paramsValue;
  const shopStaccUrl = apiconfig?.find(
    (data) => data?.paramsKey === "shopStaccUrl"
  )?.paramsValue;
  const tripStaccHotelUrl = apiconfig?.find(
    (data) => data?.paramsKey === "triphotel"
  )?.paramsValue;

  const handleRedirect = (props, label) => {
    const url = props === "trip" ? tripStaccUrl : props === "shop" ? shopStaccUrl : props === "triphotel" ? tripStaccHotelUrl : karmaRedirectionUrl;
    GAEventTracker(url, label);
    onClose();
    sessionStorage.setItem("postLoginSuccesCount", 1);
    handleRedirectWithLoading(
      setIsLoading,
      props === "trip" ? tripStaccUrl : props === "shop" ? shopStaccUrl : props === "triphotel" ? tripStaccHotelUrl : karmaRedirectionUrl,
      login,
      setShowModal,
      isModal,
      navigate,
      loginUrl
    );
  };
  const myOfferBenefit = (data, label) => {
    GAEventTracker(`/${data}`, label);
    if (data) {
      navigate(`/${data}`);
    } else {
      handleRedirectWithLoading(
        setIsLoading,
        karmaRedirectionUrl,
        login,
        setShowModal,
        isModal,
        navigate,
        loginUrl
      );
      sessionStorage.setItem("postLoginSuccesCount", 1);
    }
  };

  const GAEventTracker = (action, label) => {
    trackEvent("my_activity", {
      destination_url: action,
      cta_text: label,
      page_type: window.location.pathname === "/my-account" ? "my_account_page" : "",
      client_code: clientPlatformCode,
      platform_code: platformCode,
      user_id: userId,
      user_status: userStatus,
      card_name: defaultCardName
    });
  }

  return (
    <>
      <div className="overflow-y-auto h-full ">
        <div className="reward-link">
          <ul>
            {myActivityData && myActivityData?.length > 0 && myActivityData.map((item, index) => {
              if (item?.label?.toLowerCase() === 'voucher' && !isVouchersHistory) {
                return null;
              }
              // Only render karma point if cardName is 'first private'
              if (item?.label?.toLowerCase() === 'karmapoints') {
                if (card?.cardName?.toLowerCase() !== 'first private') {
                  return null;
                }
              }
              return (
                <>
                  <li className="activitylink" key={index} onClick={() => item.link !== 'trip' && item.link !== 'shop' && item.link !== 'triphotel' && item.link !== 'karmapoints' ? myOfferBenefit(item.link, translation?.[item.label.toLowerCase()]) : handleRedirect(item.link, translation?.[item.label.toLowerCase()])}>
                    <div className="link">
                      <img src={`${process.env.REACT_APP_CLIENT_IMAGE_URL}${clientCode}/img/${item.iconurl}`} alt="not-found" /> {translation?.[item.label.toLowerCase()]}
                      {item?.label?.toLowerCase() === 'voucher' && isVouchersHistory && <>
                        <div className="flex flex-col pt-1 ml-2">
                          <span className="text-sm">
                            {translation?.valitTill}
                          </span>
                        </div>
                      </>}
                    </div>
                    <img
                      src={arrowDownIcon}
                      alt="Arrow Icon"
                    />
                  </li>
                  {/* ✅ LAST ITEM PAR HR NAHI */}
                  {index !== myActivityData.length - 1 && (
                    <hr className="actispe" />
                  )}
                </>
              );
            })}

          </ul>
        </div>
      </div>
    </>
  );
};

export default MyActivity;
